import BaseService from './base'

export default class PublicSettingService extends BaseService {
  static resource() {
    return 'api/v1/publicSettings'
  }
}
